import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardHeader, CardContent } from "components/ui/card";
import { useAuth } from "contexts/AuthContext";

/**
 * Callback OIDC (Office 365): o backend redireciona para
 * /sso/callback#token=<JWE> (sucesso) ou #error=<msg> (falha). O fragment
 * nunca vai ao servidor.
 */
export default function OidcCallback() {
  const navigate = useNavigate();
  const { loginUser, fetchUser } = useAuth();
  const [error, setError] = useState("");

  useEffect(() => {
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const token = params.get("token");
    const err = params.get("error");
    if (err) { setError(err); return; }
    if (!token) { setError("Resposta OIDC inválida."); return; }
    (async () => {
      try {
        await loginUser({}, token);
        await fetchUser();
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      } catch {
        setError("Falha ao concluir o login SSO.");
      }
    })();
  }, [loginUser, fetchUser, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f5f5f7] px-4 py-8">
      <div className="w-full max-w-[420px]">
        <Card className="shadow-lg border-0 bg-white rounded-2xl">
          <CardHeader className="text-center">
            <h1 className="text-2xl font-bold tracking-tight text-gray-900">
              {error ? "Falha no login" : "Concluindo login…"}
            </h1>
          </CardHeader>
          <CardContent className="text-center">
            {error ? (
              <>
                <p className="text-sm text-red-500 mb-4">{error}</p>
                <button type="button" onClick={() => navigate("/login", { replace: true })}
                  className="text-sm text-blue-600 hover:underline font-medium">Voltar ao login</button>
              </>
            ) : (
              <p className="text-sm text-gray-500">Aguarde, validando autenticação SSO.</p>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
